import React, { useEffect, useMemo, useState } from "react";
import { Link } from "react-router-dom";
import PredefinedDateRanges from "../../../core/common/datePicker";
import ImageWithBasePath from "../../../core/common/imageWithBasePath";
import Table from "../../../core/common/dataTable/index";
import { all_routes } from "../../router/all_routes";
import { paymentReport } from "../../../core/data/json/paymentReport";
import ReactApexChart from "react-apexcharts";
import CollapseHeader from "../../../core/common/collapse-header/collapse-header";
import { formatDate } from "../../../core/utils/FormatData";
import {
  fetchAllBudgetReportCount,
  fetchAllBudgetReportCountMonthly,
} from "../../../core/data/redux/reports/budget_report/budget.Action";
import { AppDispatch } from "../../../core/data/redux/store";
import { useDispatch, useSelector } from "react-redux";
import { fetchAllBudgets } from "../../../core/data/redux/payroll/Accounting/budgets/budgetsAction";
import { filterData } from "../../../core/common/GlobalFunctions/tableFilters";
import {
  exportToCSV,
  exportToExcel,
} from "../../../core/common/GlobalFunctions/exportTableData";

interface BudgetReportProps {
  showOnlyTable?: boolean;
}
const BudgetReport: React.FC<BudgetReportProps> = ({ showOnlyTable}) => {
  const dispatch = useDispatch<AppDispatch>();
  const [selectedStatus, setSelectedStatus] = useState("All");
  const [selectedSort, setSelectedSort] = useState<any>("");
  const [tableKey, setTableKey] = useState(0);
  const [selectedYear, setSelectedYear] = useState("2025");
  const [count, setcount] = useState<any>("");
  const { budgets } = useSelector((state: any) => state.accounting.budget);
  const [monthlycount, setmonthlycount] = useState<any>("");
  useEffect(() => {
    dispatch(fetchAllBudgetReportCount()).then((res) => {
      setcount(res.payload.data);
    });
    dispatch(fetchAllBudgets());
    dispatch(fetchAllBudgetReportCountMonthly(selectedYear)).then((res) => {
      setmonthlycount(res.payload.data);
    });
  }, []);
  const data = budgets ? budgets : [];

  function filterBudgetData(data: any[]) {
  return data.map(budget => ({
    budgetTitle: budget.budgetTitle || "N/A",
    budgetType: budget.budgetType || "N/A",
    startDate: new Date(budget.startDate).toLocaleDateString(),
    endDate: new Date(budget.endDate).toLocaleDateString(),
    overallRevenue: budget.overallRevenue || "0.00",
    overallExpense: budget.overallExpense || "0.00",
    expectedProfit: budget.expectedProfit || "0.00",
    tax: budget.tax || "0.00",
    budgetAmount: budget.budgetAmount || "0.00"
  }));
}

const data2 = filterBudgetData(data)

  const filtereddata = useMemo(() => {
    const filters =
      selectedStatus && selectedStatus !== "All"
        ? { budgetType: selectedStatus }
        : {};
    return filterData(budgets, filters, "createdAt", "createdAt", selectedSort);
  }, [budgets, selectedStatus, selectedSort]);

  useEffect(() => {
    setTableKey((prevKey) => prevKey + 1);
  }, [selectedStatus, selectedSort, budgets]);

  const columns = [
    {
      title: "Budget Title",
      dataIndex: "budgetTitle",
      sorter: (a: any, b: any) => a.budgetTitle.length - b.budgetTitle.length,
    },
    {
      title: "Budget Type",
      dataIndex: "budgetType",
      sorter: (a: any, b: any) => a.budgetType.length - b.budgetType.length,
    },
    {
      title: "Start Date",
      dataIndex: "startDate",
      render: (text: string) => formatDate(text),
      sorter: (a: any, b: any) => a.startDate.length - b.startDate.length,
    },
    {
      title: "End Date",
      dataIndex: "endDate",
      render: (text: string) => formatDate(text),
      sorter: (a: any, b: any) => a.EndDate.length - b.EndDate.length,
    },
    {
      title: "Total Revenue",
      dataIndex: "overallRevenue",
      sorter: (a: any, b: any) =>
        a.overallRevenue.length - b.overallRevenue.length,
    },
    {
      title: "Total Expense",
      dataIndex: "overallExpense",
      sorter: (a: any, b: any) =>
        a.overallExpense.length - b.overallExpense.length,
    },
    {
      title: "Tax Amount",
      dataIndex: "tax",
      sorter: (a: any, b: any) => a.tax.length - b.tax.length,
    },
    {
      title: "Budget Amount",
      dataIndex: "budgetAmount",
      sorter: (a: any, b: any) => a.budgetAmount.length - b.budgetAmount.length,
    },
    {
      title: "Status",
      dataIndex: "status",
      render: (text: string, record: any) => (
        <span
          className={`badge ${
            text === "active" ? "badge-success" : "badge-danger"
          } d-inline-flex align-items-center badge-xs`}
        >
          <i className="ti ti-point-filled me-1" />
          {text}
        </span>
      ),
    },
  ];

  useEffect(() => {
    if (selectedYear) {
      dispatch(fetchAllBudgetReportCountMonthly(selectedYear)).then((res) => {
        setmonthlycount(res.payload.data);
      });
    }
  }, [selectedYear]);

  const handleYearSelect = (year: any) => {
    setSelectedYear(year);
  };

  useEffect(() => {
    const revenueData = new Array(12).fill(0);
    const expenseData = new Array(12).fill(0);
    const taxData = new Array(12).fill(0);
    const budgetData = new Array(12).fill(0);

    if (monthlycount && monthlycount.length > 0) {
      monthlycount.forEach(
        ({
          month,
          totalRevenue,
          totalExpense,
          totalTax,
          totalBudgetAmount,
        }: any) => {
          const index = month - 1; // Month is 1-indexed
          revenueData[index] = parseFloat(totalRevenue);
          expenseData[index] = parseFloat(totalExpense);
          taxData[index] = parseFloat(totalTax);
          budgetData[index] = parseFloat(totalBudgetAmount);
        }
      );
    }

    setattendancechart((prev: any) => ({
      ...prev,
      series: [
        {
          name: "Revenue",
          data: revenueData,
        },
        {
          name: "Expense",
          data: expenseData,
        },
        {
          name: "Amount",
          data: taxData,
        },
        {
          name: "Budget",
          data: budgetData,
        },
      ],
    }));
  }, [monthlycount]);

  const [attendancechart, setattendancechart] = useState<any>({
    // series: [
    //   {
    //     name: "Revenue",
    //     data: [
    //       5000, 7000, 6000, 8000, 9500, 11000, 10000, 12000, 11500, 13000,
    //       12500, 14000,
    //     ],
    //   },
    //   {
    //     name: "Expense",
    //     data: [
    //       3000, 4000, 3500, 5000, 5500, 6000, 5800, 6200, 6100, 6500, 6400,
    //       6700,
    //     ],
    //   },
    //   {
    //     name: "Amount",
    //     data: [
    //       2000, 3000, 2500, 3000, 4000, 5000, 4200, 5800, 5400, 6000, 6100,
    //       6300,
    //     ],
    //   },
    //   {
    //     name: "Budget",
    //     data: [
    //       6000, 7500, 7000, 8500, 10000, 11500, 10500, 12500, 12000, 13500,
    //       13000, 14500,
    //     ],
    //   },
    // ],
    series: [
      {
        name: "Revenue",
        data: new Array(12).fill(0),
      },
      {
        name: "Expense",
        data: new Array(12).fill(0),
      },
      {
        name: "Amount",
        data: new Array(12).fill(0),
      },
      {
        name: "Budget",
        data: new Array(12).fill(0),
      },
    ],
    chart: {
      height: 200,
      type: "line",
      zoom: {
        enabled: false,
      },
    },
    dataLabels: {
      enabled: false,
    },
    stroke: {
      curve: "smooth",
    },
    grid: {
      row: {
        colors: ["#f3f3f3", "transparent"],
        opacity: 0.5,
      },
    },
    xaxis: {
      categories: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ],
    },
    yaxis: {
      labels: {
        offsetX: -15,
      },
    },
    colors: ["#4CAF50", "#FF5722", "#2196F3", "#FFC107"],
  });

  if (showOnlyTable) {
  return (
   <Table
     key={tableKey}
     dataSource={filtereddata}
     columns={columns}
     Selection={true}
    />
  );
}
  return (
    <>
      {/* Page Wrapper */}
      <div className="page-wrapper">
        <div className="content">
          {/* Breadcrumb */}
          <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
            <div className="my-auto mb-2">
              <h2 className="mb-1">Budget Report</h2>
              <nav>
                <ol className="breadcrumb mb-0">
                  <li className="breadcrumb-item">
                    <Link to={all_routes.adminDashboard}>
                      <i className="ti ti-smart-home" />
                    </Link>
                  </li>
                  <li className="breadcrumb-item">HR</li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Budgets
                  </li>
                </ol>
              </nav>
            </div>
            <div className="d-flex my-xl-auto right-content align-items-center flex-wrap ">
              <div className="mb-2">
                <div className="dropdown">
                  <Link
                    to="#"
                    className="dropdown-toggle btn btn-white d-inline-flex align-items-center"
                    data-bs-toggle="dropdown"
                  >
                    <i className="ti ti-file-export me-1" />
                    Export
                  </Link>
                  <ul className="dropdown-menu  dropdown-menu-end p-3">
                    <li>
                      <button
                        onClick={() => exportToCSV(data2, "Budget_Report")}
                        className="dropdown-item rounded-1"
                      >
                        <i className="ti ti-file-type-pdf me-1" />
                        Export as CSV
                      </button>
                    </li>
                    <li>
                      <button
                        onClick={() => exportToExcel(data2, "Budget_Report")}
                        className="dropdown-item rounded-1"
                      >
                        <i className="ti ti-file-type-xls me-1" />
                        Export as Excel{" "}
                      </button>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="head-icons ms-2">
                <CollapseHeader />
              </div>
            </div>
          </div>
          {/* /Breadcrumb */}
          <div className="row">
            {/* Total Exponses */}
            <div className="col-xl-6 d-flex">
              <div className="row flex-fill">
                <div className="col-lg-6 col-md-6 d-flex">
                  <div className="card flex-fill">
                    <div className="card-body ">
                      <div className="d-flex flex-wrap align-items-center justify-content-between border-bottom pb-2">
                        <div className="d-flex align-items-center flex-column overflow-hidden">
                          <div>
                            <div>
                              <span className="fs-14 fw-normal text-truncate mb-1">
                                Total Revenue
                              </span>
                              <h5>{count ? count?.[0].totalRevenue : 0}</h5>
                            </div>
                          </div>
                        </div>
                        <div className="d-flex justify-content-between align-items-center flex-wrap">
                          <Link
                            to="#"
                            className="avatar avatar-md br-5 payment-report-icon  bg-transparent-primary border border-primary"
                          >
                            <span className="text-primary">
                              <i className="ti ti-currency-rupee" />
                            </span>
                          </Link>
                        </div>
                      </div>
                      {/* <div className="d-flex justify-content-center mt-2">
                                                <p className="fs-12 fw-normal d-flex align-items-center text-truncate">
                                                    <span className="text-success fs-12 d-flex align-items-center me-1">
                                                        <i className="ti ti-arrow-wave-right-up me-1" />
                                                        +20.01%
                                                    </span>
                                                    from last week
                                                </p>
                                            </div> */}
                    </div>
                  </div>
                </div>
                <div className="col-lg-6 col-md-6 d-flex">
                  <div className="card flex-fill">
                    <div className="card-body ">
                      <div className="d-flex flex-wrap align-items-center justify-content-between border-bottom pb-2">
                        <div className="d-flex align-items-center flex-column overflow-hidden">
                          <div>
                            <div>
                              <span className="fs-14 fw-normal text-truncate mb-1">
                                Total Expense
                              </span>
                              <h5>{count ? count?.[0].totalExpense : 0}</h5>
                            </div>
                          </div>
                        </div>
                        <div className="d-flex justify-content-between align-items-center flex-wrap">
                          <Link
                            to="#"
                            className="avatar avatar-md br-5 payment-report-icon  bg-transparent-skyblue border border-skyblue"
                          >
                            <span className="text-skyblue">
                              <i className="ti ti-currency-rupee" />
                            </span>
                          </Link>
                        </div>
                      </div>
                      {/* <div className="d-flex justify-content-center mt-2">
                                                <p className="fs-12 fw-normal d-flex align-items-center text-truncate">
                                                    <span className="text-success fs-12 d-flex align-items-center me-1">
                                                        <i className="ti ti-arrow-wave-right-up me-1" />
                                                        +20.01%
                                                    </span>{" "}
                                                    from last week
                                                </p>
                                            </div> */}
                    </div>
                  </div>
                </div>
                <div className="col-lg-6 col-md-6 d-flex">
                  <div className="card flex-fill">
                    <div className="card-body ">
                      <div className="d-flex flex-wrap align-items-center justify-content-between border-bottom pb-2">
                        <div className="d-flex align-items-center flex-column overflow-hidden">
                          <div>
                            <div>
                              <span className="fs-14 fw-normal text-truncate mb-1">
                                Tax Amount
                              </span>
                              <h5>{count ? count?.[0].totalTax : 0}</h5>
                            </div>
                          </div>
                        </div>
                        <div className="d-flex justify-content-between align-items-center flex-wrap">
                          <Link
                            to="#"
                            className="avatar avatar-md br-5 payment-report-icon  bg-transparent-danger border border-danger"
                          >
                            <span className="text-danger">
                              <i className="ti ti-currency-rupee" />
                            </span>
                          </Link>
                        </div>
                      </div>
                      {/* <div className="d-flex justify-content-center mt-2">
                                                <p className="fs-12 fw-normal d-flex align-items-center text-truncate">
                                                    <span className="text-danger fs-12 d-flex align-items-center me-1">
                                                        <i className="ti ti-arrow-wave-right-up me-1" />
                                                        +20.01%
                                                    </span>{" "}
                                                    from last week
                                                </p>
                                            </div> */}
                    </div>
                  </div>
                </div>
                <div className="col-lg-6 col-md-6 d-flex">
                  <div className="card flex-fill">
                    <div className="card-body ">
                      <div className="d-flex flex-wrap align-items-center justify-content-between border-bottom pb-2">
                        <div className="d-flex align-items-center flex-column overflow-hidden">
                          <div>
                            <div>
                              <span className="fs-14 fw-normal text-truncate mb-1">
                                Budget Amount
                              </span>
                              <h5>
                                {count ? count?.[0].totalBudgetAmount : 0}
                              </h5>
                            </div>
                          </div>
                        </div>
                        <div className="d-flex justify-content-between align-items-center flex-wrap">
                          <Link
                            to="#"
                            className="avatar avatar-md br-5 payment-report-icon  bg-pink-transparent border border-pink"
                          >
                            <span className="text-pink">
                              <i className="ti ti-currency-dollar" />
                            </span>
                          </Link>
                        </div>
                      </div>
                      {/* <div className="d-flex justify-content-center mt-2">
                                                <p className="fs-12 fw-normal d-flex align-items-center text-truncate">
                                                    <span className="text-success fs-12 d-flex align-items-center me-1">
                                                        <i className="ti ti-arrow-wave-right-up me-1" />
                                                        +20.01%
                                                    </span>{" "}
                                                    from last week
                                                </p>
                                            </div> */}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* /Total Exponses */}
            {/* Total Exponses */}
            <div className="col-xl-6">
              <div className="card">
                <div className="card-header border-0 pb-0">
                  <div className="d-flex flex-wrap justify-content-between align-items-center">
                    <div className="d-flex align-items-center ">
                      <span className="me-2">
                        <i className="ti ti-chart-line text-danger" />
                      </span>
                      <h5>Budget</h5>
                    </div>
                    <div className="dropdown">
                      <Link
                        to="#"
                        className="dropdown-toggle btn btn-sm fs-12 btn-white d-inline-flex align-items-center"
                        data-bs-toggle="dropdown"
                      >
                        {selectedYear}
                      </Link>
                      <ul className="dropdown-menu  dropdown-menu-end p-2">
                        <li>
                          <Link
                            to="#"
                            className="dropdown-item rounded-1"
                            onClick={() => handleYearSelect("2025")}
                          >
                            2025
                          </Link>
                        </li>
                        <li>
                          <Link
                            to="#"
                            className="dropdown-item rounded-1"
                            onClick={() => handleYearSelect("2024")}
                          >
                            2024
                          </Link>
                        </li>
                        <li>
                          <Link
                            to="#"
                            className="dropdown-item rounded-1"
                            onClick={() => handleYearSelect("2023")}
                          >
                            2023
                          </Link>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div className="card-body py-0 px-2">
                  <ReactApexChart
                    id="payslip-chart"
                    options={attendancechart}
                    series={attendancechart.series}
                    type="line"
                    height={200}
                  />
                </div>
              </div>
            </div>
            {/* /Total Exponses */}
          </div>
          <div className="card">
            <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
              <h5>Budget List</h5>
              <div className="d-flex my-xl-auto right-content align-items-center flex-wrap row-gap-3">
                <div className="dropdown me-3">
                  <Link
                    to="#"
                    className="dropdown-toggle btn btn-sm btn-white d-inline-flex align-items-center"
                    data-bs-toggle="dropdown"
                  >
                    {selectedStatus
                      ? selectedStatus.charAt(0).toUpperCase() +
                        selectedStatus.slice(1)
                      : "Select Type"}
                  </Link>
                  <ul className="dropdown-menu dropdown-menu-end p-3">
                    <li>
                      <Link
                        to="#"
                        onClick={() => setSelectedStatus("All")}
                        className="dropdown-item rounded-1"
                      >
                        All
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="#"
                        onClick={() => setSelectedStatus("project")}
                        className="dropdown-item rounded-1"
                      >
                        Project
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="#"
                        onClick={() => setSelectedStatus("category")}
                        className="dropdown-item rounded-1"
                      >
                        Category
                      </Link>
                    </li>
                  </ul>
                </div>

                <div className="dropdown">
                  <Link
                    to="#"
                    className="dropdown-toggle btn btn-sm btn-white d-inline-flex align-items-center"
                    data-bs-toggle="dropdown"
                  >
                    {selectedSort
                      ? `Sort By : ${selectedSort}`
                      : "Sort By : Last 7 Days"}
                  </Link>
                  <ul className="dropdown-menu dropdown-menu-end p-3">
                    <li>
                      <Link
                        to="#"
                        onClick={() => setSelectedSort("Recently Added")}
                        className="dropdown-item rounded-1"
                      >
                        Recently Added
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="#"
                        onClick={() => setSelectedSort("Ascending")}
                        className="dropdown-item rounded-1"
                      >
                        Ascending
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="#"
                        onClick={() => setSelectedSort("Descending")}
                        className="dropdown-item rounded-1"
                      >
                        Descending
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="#"
                        onClick={() => setSelectedSort("Last Month")}
                        className="dropdown-item rounded-1"
                      >
                        Last Month
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="#"
                        onClick={() => setSelectedSort("Last 7 Days")}
                        className="dropdown-item rounded-1"
                      >
                        Last 7 Days
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="card-body p-0">
              <Table
                key={tableKey}
                dataSource={filtereddata}
                columns={columns}
                Selection={true}
              />
            </div>
          </div>
        </div>
        <div className="footer d-sm-flex align-items-center justify-content-between border-top bg-white p-3">
          <p className="mb-0">2024 - 2025© hrmtree.</p>
          <p>
            Developed By{" "}
            <Link to="#" className="text-primary">
              Leadchain Systems
            </Link>
          </p>
        </div>
      </div>
      {/* /Page Wrapper */}
    </>
  );
};

export default BudgetReport;
